import React from 'react'
import logo from '../img/logo.png';
import {Link} from 'react-router-dom';

export default function Footer() {
  return (
    <>
      <footer id="footer">
  
  <div className="footer-top">
    <div className="container">
      <div className="row">

        <div className="col-lg-2 col-md-12 footer-contact" style={{marginTop:"8px"}}>
          <img src={logo} alt="" style={{width:"100%"}}/><br/><br/>
          <p style={{fontSize: "12px"}}>
            Shree Siddhi Vinayak Engineering <br/>D/8, Sayan Textile Park, Ichhapore, Chorasi, Surat
          </p>
        </div>

        <div id="explore" className="col-lg-2 col-md-12 footer-links">
          <h4>Explore</h4>
          <ul>
            <div className="division col-12">
              <li><i className="bx bx-chevron-right"></i><Link className="nav-link" to="/">Home</Link></li>
              <li><i className="bx bx-chevron-right"></i><Link className="nav-link" to="/aboutus">About Us</Link></li>
              <li><i className="bx bx-chevron-right"></i><Link className="nav-link" to="/gallery">Gallery</Link></li>
              <li><i className="bx bx-chevron-right"></i><Link className="nav-link" to="/patterndesign">Pattern Design</Link></li>
              <li><i className="bx bx-chevron-right"></i><Link className="nav-link" to="/contact">Contact Us</Link></li>
            </div>
          </ul>
        </div>

        <div id="capabilitise" className="col-lg-4 col-md-12 footer-links">
          <h4>Capabilities</h4>
          <ul>
            <div className="division col-12">
              <li><i className="bx bx-chevron-right"></i> <Link to="/">CNC Laser Cutting</Link></li>
              <li><i className="bx bx-chevron-right"></i> <Link to="/">CNC Bending</Link></li>
               <li><i className="bx bx-chevron-right"></i> <Link to="/">Fabrication</Link></li>
            </div>
          </ul>
        </div>

        <div className="col-lg-3 col-md-6 footer-links">
          <h4>Follow Us</h4>
          <div className="social-links">
            <a href="#" className="youtube"><i className="fab fa-instagram"></i></a>
            <a href="#" className="instagram"><i className="fab fa-youtube"></i></a>
            <a href="#" className="linkedin"><i className="fab fa-linkedin"></i></a>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div id="copyright-footer" className="container">
    <div className="copyright">
      <span>© 2024 - {new Date().getFullYear()} Shree Siddhi Vinayak Engineering | All Rights Reserved</span>
    </div>
  </div>
</footer>
    </>
  )
}
